import { render } from "./home-new.vue?vue&type=template&id=67164a7a&scoped=true"
import script from "./home-new.vue?vue&type=script&lang=js"
export * from "./home-new.vue?vue&type=script&lang=js"

import "./home-new.vue?vue&type=style&index=0&id=67164a7a&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67164a7a"]])

export default __exports__